import { GRID_GAP_PX, GRID_ROW_PX } from '../constants';

/** Aantal rasterrijen voor een blok van `height` pixels, inclusief de tussenruimte eronder. */
export function rowSpanFor(height: number): number {
  return Math.ceil((Math.max(0, height) + GRID_GAP_PX) / GRID_ROW_PX);
}
